import { render, staticRenderFns } from "./App.vue?vue&type=template&id=df2b0d9c&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2b0d9c",
  null
  
)

export default component.exports